import styles from './table-pagination.module.scss';
import { MenuItem, Pagination, Select, Typography } from '@frontend-workspace/react-shared-lib';
import { GridApi } from 'ag-grid-community';
import { t } from 'i18next';

/* eslint-disable-next-line */
export interface TablePaginationMuiProps {
  pageSize: number,
  onChangePageSize: (pageSize: number) => void,
  gridApi: GridApi | null,
  currentPage: number,
  rowCount: number,
  pageCount: number
}

export function TablePaginationMui(props: TablePaginationMuiProps) {
  const muiPaginationChanged = (e: any, page: number) => {
    props.gridApi?.paginationGoToPage(page - 1);
  };

  return (
    <div className='d-flex flex-md-row flex-wrap justify-content-end align-items-center'>
      <div className='mt-4 pe-4 d-flex align-items-center'>
        <Typography component='span' variant='body6' className='pe-1'>
          {t("simpleTable.showQuantity")}:
        </Typography>
        <Select
          value={props.pageSize}
          onChange={props.onChangePageSize}>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={100}>100</MenuItem>
        </Select>
      </div>
      <div className='mt-4 pe-4'>
        <Typography component='span' variant='body6'>
          {t("simpleTable.total")}: {props.rowCount}
        </Typography>
      </div>
      <div>
        {!!props.pageSize &&
          <Pagination
            className="d-flex justify-content-end mt-4"
            count={props.pageCount || 0}
            page={props.currentPage || 0}
            onChange={muiPaginationChanged}
          />
        }
      </div>
    </div>
  );
}

export default TablePaginationMui;